export class JobOwnershipTemplateItem {
    id!: string
    jobOwnershipTemplateId!: string
    name!: string
    order!: number
    assignedRole?: number | null
}
